/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import './style/productCostsUpload.scss';

import {AwesomeIcon, ChangeFunction, Checkbox, CloseButton, Link, Loader, WithBackground} from '@dvrd/dvr-controls';
import React, {ChangeEventHandler, MouseEventHandler, useRef} from 'react';
import {BolmateButton} from "../../controls";

interface Props {
    onClose: MouseEventHandler;
    onDownloadTemplate: MouseEventHandler;
    onDownloadProductCosts: MouseEventHandler;
    onChangeFile: ChangeEventHandler<HTMLInputElement>;
    onSubmit: MouseEventHandler;
    onChangeDeleteCurrent: ChangeFunction<boolean>;
    importFile: File | null;
    loading: boolean;
    active: boolean;
    deleteCurrent: boolean;
}

export default function ProductCostsUpload(props: Props) {
    const {
        importFile, onChangeFile, onDownloadTemplate, loading, onSubmit, active, onClose, onChangeDeleteCurrent,
        deleteCurrent, onDownloadProductCosts
    } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    function onOpenFileSelection() {
        inputRef.current?.click();
    }

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading}/>
                <p className='info'>
                    Je kunt hier de kosten (<b>excl. BTW</b>) van producten in bulk uploaden.<br/>
                </p>
                <input type='file' ref={inputRef} style={{display: 'none'}} onChange={onChangeFile} accept='.xlsx'/>
                <label className='sub-title'>Importbestand uploaden</label>
                <div className='file-container' onClick={onOpenFileSelection}>
                    <AwesomeIcon name='file-excel' className='excel-icon'/>
                    {renderFileLabel()}
                </div>
                <div className='delete-container'>
                    <Checkbox checked={deleteCurrent} onCheck={onChangeDeleteCurrent}
                              label='Alle huidige kosten verwijderen' baseColor='red'/>
                    {deleteCurrent &&
                        <label className='delete-warning'><AwesomeIcon name='exclamation-triangle'/> Hiermee
                            worden <b><u>alle</u></b> reeds ingestelde productkosten verwijderd, dus ook van producten
                            die niet in het importbestand staan.</label>}
                </div>
                <label className='info'>
                    <Link onClick={onDownloadTemplate}>Bekijk en download hier</Link> het voorbeeld van het juiste
                    format.
                    <br/>
                    Upload enkel een .xlsx bestand (Excel standaard) in de opmaak uit het voorbeeld.
                </label>
                <label className='info'>
                    <Link onClick={onDownloadProductCosts}>Download hier</Link> alle productkosten die je al ingesteld
                    hebt.
                </label>
            </div>
        )
    }

    function renderFileLabel() {
        const fileName = importFile?.name ?? 'Kies een .xlsx bestand om te uploaden...';
        return <label className='file-name'>{fileName}</label>;
    }

    return (
        <WithBackground active={active} onClose={onClose} allowBodyScroll>
            <div className='import-product-costs default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Productkosten importeren</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BolmateButton onClick={onClose} label='Annuleren' disabled={loading} secondary/>
                    <BolmateButton onClick={onSubmit} label='Uploaden' disabled={loading || !importFile}/>
                </div>
            </div>
        </WithBackground>
    )
}